import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetCategoriesSlice = createSlice({
    name: "getCategories",
    initialState,
    reducers: {
        getCategoriesRequest(state) {
            state.loading = true;
        },
        getCategoriesRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getCategoriesRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        clearCategoriesResponse(state) {
            state.response = undefined;
            state.error = undefined;
            state.loading = false;
        }
    },
});

export const {
    getCategoriesRequest,
    getCategoriesRequestSuccess,
    getCategoriesRequestError,
    clearCategoriesResponse
} = GetCategoriesSlice.actions;

export default GetCategoriesSlice.reducer;
